module.exports = __webpack_public_path__ + "img/11-23-183.78fdb135.jpg";